<template>
    <div>
        <div class="sheet-backdrop" :class="{open: visible}" @click="close"></div>
        <div class="bottom-sheet" :class="{open: visible}" :style="{maxHeight: maxHeight}" role="dialog">
            <div class="grab"></div>
            <div class="sheet-head" v-if="$slots.header">
                <slot name="header"></slot>
            </div>
            <div class="sheet-body">
                <slot></slot>
            </div>
            <div class="sheet-footer" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomSheet",
    props: {
        //inaltimea maxima a sheet-ului; continutul din slotul default face scroll
        maxHeight: {
            type: String,
            default: '86vh'
        }
    },
    data() {
        return {
            visible: false
        }
    },
    methods: {
        open() {
            this.visible = true;
            document.body.classList.add("sheet-open");
        },
        close() {
            this.visible = false;
            document.body.classList.remove("sheet-open");
            this.$emit("close");
        }
    },
    beforeDestroy() {
        document.body.classList.remove("sheet-open");
    }
}
</script>

<style lang="less" scoped>
.sheet-backdrop {
    position: fixed;
    inset: 0;
    z-index: 100;
    background: rgba(12, 14, 10, .45);
    opacity: 0;
    pointer-events: none;
    transition: opacity .25s;

    &.open {
        opacity: 1;
        pointer-events: auto;
    }
}

.bottom-sheet {
    position: fixed;
    left: 0; right: 0; bottom: 0;
    z-index: 110;
    margin: 0 auto;
    max-width: 560px;
    background: var(--m-card);
    border-radius: 24px 24px 0 0;
    transform: translateY(102%);
    transition: transform .3s cubic-bezier(.32, .72, .28, 1);
    display: flex;
    flex-direction: column;
    box-shadow: 0 -8px 30px rgba(0, 0, 0, .18);

    &.open {
        transform: translateY(0);
    }

    .grab {
        width: 38px;
        height: 4px;
        border-radius: 99px;
        background: var(--m-line);
        margin: 10px auto 4px;
        flex: 0 0 auto;
    }

    .sheet-head {
        flex: 0 0 auto;
        padding: 8px 20px 0;
    }

    .sheet-body {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding: 8px 20px 16px;
    }

    .sheet-footer {
        flex: 0 0 auto;
        padding: 12px 20px calc(16px + env(safe-area-inset-bottom));
        border-top: 1px solid var(--m-line);
    }
}

@media (prefers-reduced-motion: reduce) {
    .bottom-sheet, .sheet-backdrop {
        transition: none;
    }
}
</style>
